export const REMOVE_TESTIMONIALS = 'REMOVE_TESTIMONIALS';
export const SET_TESTIMONIALS = 'SET_TESTIMONIALS';
